import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import AuthenticatedLayout from '../layout/AuthenticatedLayout'
import Layout from '../layout/Layout'
import LoginPage from '../pages/authentication/LoginPage'
import RegisterPage from '../pages/authentication/RegisterPage'
import PatientsPage from '../pages/dashboard/Patients'
import DoctorsPage from '../pages/dashboard/Doctors'
import OtherUseraPage from '../pages/dashboard/OtherUsers'
import { PatientProfilePage } from '../pages/dashboard/PatientProfile'

export const routes = {
  patients: '/patients',
  patient: (patientId: string | ':patientId' = ':patientId') => `/patients/${patientId}`,
  doctors: '/doctors',
  otherUsers: '/other-users',
  login: '/',
  register: '/register',
}

export const Router = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<Layout />}>
        <Route path={routes.login} element={<LoginPage />} />
        <Route path={routes.register} element={<RegisterPage />} />
      </Route>
      <Route element={<AuthenticatedLayout />}>
        <Route path={routes.patients} element={<PatientsPage />} />
        <Route path={routes.doctors} element={<DoctorsPage />} />
        <Route path={routes.otherUsers} element={<OtherUseraPage />} />

        {/* Dynamic patient route: /patients/:patientId */}
        <Route path={routes.patient()} element={<PatientProfilePage />} />
      </Route>
    </Routes>
  </BrowserRouter>
)
